
















import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "projectSelect",
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    ...mapState("LoginInfo", ["project"]),
    projectId() {
      return this.$route.params.projectId;
    }
  }
});
